import { lazy } from "react";

import GroupsIcon from "@mui/icons-material/Groups";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import DirectionsBusFilledIcon from "@mui/icons-material/DirectionsBusFilled";
import AddIcon from "@mui/icons-material/Add";
import ApartmentIcon from "@mui/icons-material/Apartment";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import PersonIcon from "@mui/icons-material/Person";
import ManageAccountsOutlinedIcon from "@mui/icons-material/ManageAccountsOutlined";

const SchoolManagerNavBoxItems = [
  {
    name: "پروفایل مدرسه",
    path: "/school/manager/profile",
    icon: ApartmentIcon,
  },
  {
    name: "دانش‌آموزان/افزودن",
    path: "/school/manager/students",
    icon: GroupsIcon,
  },
  {
    name: "سرویس‌ها",
    path: "/school/manager/services",
    icon: DirectionsBusFilledIcon,
  },
  {
    name: "افزودن سرویس",
    path: "/school/manager/service",
    icon: AddIcon,
  },
  // {
  //   name: "مالی",
  //   path: "/school/manager/financial",
  //   icon: PointOfSaleIcon,
  // },
  {
    name: "اپراتورها",
    path: "/school/manager/operator",
    icon: ManageAccountsOutlinedIcon,
  },
];

const EmployeeOrganizationNavBoxItems = [
  {
    name: "اطلاعات سازمان",
    path: "/organization/employee/profile",
    icon: PersonIcon,
  },
  {
    name: "سرویس ها",
    path: "/organization/employee/services",
    icon: DirectionsBusFilledIcon,
  },
  {
    name: "حساب مالی",
    path: "/organization/employee/invoice",
    icon: PointOfSaleIcon,
  },
];

const SchoolStudentNavBoxItems = {
  student: [
    {
      name: "اطلاعات فردی",
      path: "/school/student/profile",
      icon: PersonIcon,
    },
    {
      name: "سرویس ها",
      path: "/school/student/services",
      icon: DirectionsBusFilledIcon,
    },
    {
      name: "حساب مالی",
      path: "/school/student/invoice",
      icon: PointOfSaleIcon,
    },
  ],
  parent:
    localStorage.getItem("agent_service") === "shahrzad"
      ? [
          {
            name: "فرزندان",
            path: "/school/parent/students",
            icon: GroupsIcon,
          },
          {
            name: "سرویس‌ها",
            path: "/school/parent/services",
            icon: DirectionsBusFilledIcon,
          },
          {
            name: "حساب مالی",
            path: "/school/parent/invoice",
            icon: PointOfSaleIcon,
          },
        ]
      : [
          {
            name: "پروفایل",
            path: "/school/parent/profile",
            icon: PersonIcon,
          },
          {
            name: "فرزندان",
            path: "/school/parent/students",
            icon: GroupsIcon,
          },
          {
            name: "سرویس‌ها",
            path: "/school/parent/services",
            icon: DirectionsBusFilledIcon,
          },
          {
            name: "حساب مالی",
            path: "/school/parent/invoice",
            icon: PointOfSaleIcon,
          },
        ],
};
const OrganizationManagerNavBoxItems = [
  {
    name: "پروفایل سازمان",
    path: "/organization/manager/profile",
    icon: ApartmentIcon,
  },
  {
    name: "کارمندان",
    path: "/organization/manager/staff",
    icon: GroupsIcon,
  },
  // {
  //   name: "افزودن کارمند",
  //   path: "/organization/manager/staff/add",
  //   icon: PersonAddAltIcon,
  // },
  {
    name: "سرویس‌ها",
    path: "/organization/manager/services",
    icon: DirectionsBusFilledIcon,
  },
  {
    name: "افزودن سرویس",
    path: "/organization/manager/service",
    icon: AddIcon,
  },
  {
    name: "اپراتورها",
    path: "/organization/manager/operator",
    icon: ManageAccountsOutlinedIcon,
  },
];

const Routes = [
  // Main routes
  {
    path: "/wallets",
    exact: true,
    component: lazy(() =>
      import("@package/behamrah-core/dist/pages/panel/wallets")
    ),
    layout: "PanelLayout",
    name: "کیف پول ها",
  },
  {
    path: "/walletLogin/:wallet",
    exact: true,
    component: lazy(() =>
      import("@package/behamrah-core/dist/pages/panel/walletLogin")
    ),
    layout: "PanelLayout",
  },
  {
    path: "/paths",
    exact: true,
    component: lazy(() =>
      import("@package/behamrah-core/dist/pages/panel/paths")
    ),
    layout: "BlankLayout", // This page have custom layout in its own folder
    name: "مسیرها",
  },

  {
    path: "/referral",
    exact: true,
    component: lazy(() =>
      import("@package/behamrah-core/dist/pages/panel/referral")
    ),
    layout: "PanelLayout",
    name: "معرفی به دوستان",
  },
  {
    path: "/hiring",
    exact: true,
    component: lazy(() =>
      import("@package/behamrah-core/dist/pages/panel/hiring")
    ),
    layout: "PanelLayoutNoPadding",
    name: "پیشنهاد مسیر",
  },
  {
    path: "/hiring/:id",
    exact: true,
    component: lazy(() =>
      import("@package/behamrah-core/dist/pages/panel/hiringDetail")
    ),
    layout: "PanelLayoutNoPadding",
    name: "پیشنهاد مسیر",
  },
  {
    path: "/hiring-list",
    exact: true,
    component: lazy(() =>
      import("@package/behamrah-core/dist/pages/panel/hiringList")
    ),
    layout: "PanelLayout",
    name: "سفرها",
  },
  {
    path: "/cart",
    exact: true,
    component: lazy(() =>
      import("@package/behamrah-core/dist/pages/panel/cart")
    ),
    layout: "PanelLayout",
    name: "سبد خرید",
  },
  {
    path: "/tickets/:status?",
    exact: true,
    component: lazy(() =>
      import("@package/behamrah-core/dist/pages/panel/tickets")
    ),
    layout: "PanelLayout",
    name: "بلیط ها",
  },
  {
    path: "/addresses",
    exact: true,
    component: lazy(() =>
      import("@package/behamrah-core/dist/pages/panel/addresses")
    ),
    layout: "PanelLayout",
    name: "آدرس ها",
  },
  {
    path: "/survey",
    exact: true,
    component: lazy(() =>
      import("@package/behamrah-core/dist/pages/panel/survey")
    ),
    layout: "PanelLayout",
    name: "پیشنهاد مسیر",
  },
  {
    path: "/ticketDetails/:status/:code",
    exact: true,
    component: lazy(() =>
      import("@package/behamrah-core/dist/pages/panel/ticketDetails")
    ),
    layout: "PanelLayout",
  },
  {
    path: "/callback/:from?/:status?/:refId?",
    exact: true,
    component: lazy(() =>
      import("@package/behamrah-core/dist/pages/panel/callback")
    ),
    layout: "PanelLayout",
  },

  // Passenger panel
  {
    path: "/app",
    exact: true,
    component: lazy(() => import("../pages/app")),
    layout: "BlankLayout",
  },
  {
    path: "/profile",
    exact: true,
    component: lazy(() => import("../pages/profile")),
    layout: "PanelLayout",
    name: "پروفایل",
  },
  {
    path: "/path/:path?/:tab?",
    exact: true,
    component: lazy(() => import("../pages/path")),
    layout: "PanelLayout",
    name: "جزئیات مسیر",
  },
  {
    path: "/profile/edit",
    exact: true,
    component: lazy(() => import("../pages/profile/edit")),
    layout: "PanelLayout",
    name: "پروفایل - ویرایش",
  },
  {
    path: "/hiring-list",
    exact: true,
    component: lazy(() => import("../pages/hiringList")),
    layout: "PanelLayout",
    name: "سفرها",
  },
  {
    path: "/weekly-plan",
    exact: true,
    component: lazy(() => import("../pages/weeklyPlan")),
    layout: "PanelLayout",
    name: "برنامه هفتگی",
  },
  {
    path: "/ridesharing/:role?/:tab?",
    exact: true,
    component: lazy(() => import("../pages/ridesharing")),
    layout: "PanelLayout",
    name: "همپیمایی",
  },
  // School Manager Routes
  {
    path: "/school/manager/register",
    exact: true,
    component: lazy(() => import("../pages/school/manager/profile")),
    layout: "BlankLayout",
    name: "مدرسه - ثبت نام",
  },
  {
    path: "/school/manager/profile",
    exact: true,
    component: lazy(() => import("../pages/school/manager/profile")),
    layout: "PanelLayout",
    name: "مدرسه - پروفایل",
    navBoxItems: SchoolManagerNavBoxItems,
  },
  {
    path: "/school/manager/students",
    exact: true,
    component: lazy(() => import("../pages/school/manager/students")),
    layout: "PanelLayout",
    name: "مدرسه - دانش آموزان",
    navBoxItems: SchoolManagerNavBoxItems,
  },
  {
    path: "/school/manager/services",
    exact: true,
    component: lazy(() => import("../pages/school/services")),
    layout: "PanelLayout",
    name: "مدرسه - سرویس‌ها",
    navBoxItems: SchoolManagerNavBoxItems,
  },
  {
    path: "/school/manager/inventories/:code",
    exact: true,
    component: lazy(() => import("../pages/common/inventories")),
    layout: "PanelLayout",
    name: "مدرسه - برنامه حرکت",
    navBoxItems: SchoolManagerNavBoxItems,
  },
  {
    path: "/school/manager/service/:code?",
    exact: true,
    component: lazy(() => import("../pages/school/manager/service")),
    layout: "PanelLayout",
    name: "مدرسه - ثبت سرویس",
    navBoxItems: SchoolManagerNavBoxItems,
  },
  {
    path: "/school/manager/operator",
    exact: true,
    component: lazy(() => import("../pages/school/manager/operator")),
    layout: "PanelLayout",
    name: "مدرسه - اپراتور‌ها",
    navBoxItems: SchoolManagerNavBoxItems,
  },

  // School Student/Parent Routes
  {
    path: "/school/student",
    exact: true,
    component: lazy(() => import("../pages/school/student")),
    layout: "PanelLayout",
    name: "مدرسه - دانش‌آموز",
  },
  {
    path: "/school/student/terms",
    exact: true,
    component: lazy(() => import("../pages/school/student/terms")),
    layout: "BlankLayout",
    name: "مدرسه - شرایط استفاده",
  },
  // EmployeeOrganization

  {
    path: "/organization/employee/profile",
    exact: true,
    component: lazy(() =>
      import("../pages/organization/employee/profile/index")
    ),
    layout: "PanelLayout",
    name: "سازمان - اطلاعات سازمان",
    navBoxItems: EmployeeOrganizationNavBoxItems,
  },
  {
    path: "/organization/employee/services",
    exact: true,
    component: lazy(() =>
      import("../pages/organization/employee/services/index")
    ),
    layout: "PanelLayout",
    name: "سازمان - سرویس ها",
    navBoxItems: EmployeeOrganizationNavBoxItems,
  },
  {
    path: "/organization/employee/invoice",
    exact: true,
    component: lazy(() =>
      import("../pages/organization/employee/invoice/index")
    ),
    layout: "PanelLayout",
    name: "سازمان - فاکتور ها",
    navBoxItems: EmployeeOrganizationNavBoxItems,
  },
  // School Student Routes
  {
    path: "/school/student/profile",
    exact: true,
    component: lazy(() => import("../pages/school/student/profile")),
    layout: "PanelLayout",
    name: "مدرسه - حساب مالی",
    navBoxItems: SchoolStudentNavBoxItems.student,
  },
  {
    path: "/school/student/services",
    exact: true,
    component: lazy(() => import("../pages/school/services")),
    layout: "PanelLayout",
    name: "مدرسه - سرویس ها",
    navBoxItems: SchoolStudentNavBoxItems.student,
  },
  {
    path: "/school/student/invoice",
    exact: true,
    component: lazy(() => import("../pages/school/student/invoice")),
    layout: "PanelLayout",
    name: "مدرسه - حساب مالی",
    navBoxItems: SchoolStudentNavBoxItems.student,
  },
  {
    path: "/school/student/inventories/:code",
    exact: true,
    component: lazy(() => import("../pages/common/inventories")),
    layout: "PanelLayout",
    name: "مدرسه - برنامه حرکت",
    navBoxItems: SchoolStudentNavBoxItems.student,
  },

  // School Parent Routes
  {
    path: "/school/parent/profile",
    exact: true,
    component: lazy(() => import("../pages/school/student/parentProfile")),
    layout: "PanelLayout",
    name: "مدرسه - اطلاعات فردی",
    navBoxItems: SchoolStudentNavBoxItems.parent,
  },
  {
    path: "/school/parent/students",
    exact: true,
    component: lazy(() => import("../pages/school/student/students")),
    layout: "PanelLayout",
    name: "مدرسه - لیست فرزندان",
    navBoxItems: SchoolStudentNavBoxItems.parent,
  },
  {
    path: "/school/parent/services",
    exact: true,
    component: lazy(() => import("../pages/school/services")),
    layout: "PanelLayout",
    name: "مدرسه - سرویس ها",
    navBoxItems: SchoolStudentNavBoxItems.parent,
  },
  {
    path: "/school/parent/invoice",
    exact: true,
    component: lazy(() => import("../pages/school/student/invoice")),
    layout: "PanelLayout",
    name: "مدرسه - حساب مالی",
    navBoxItems: SchoolStudentNavBoxItems.parent,
  },
  {
    path: "/school/parent/inventories/:code",
    exact: true,
    component: lazy(() => import("../pages/common/inventories")),
    layout: "PanelLayout",
    name: "مدرسه - برنامه حرکت",
    navBoxItems: SchoolStudentNavBoxItems.parent,
  },

  // Organization Routes
  {
    path: "/organization/manager/register",
    exact: true,
    component: lazy(() => import("../pages/organization/manager/profile")),
    layout: "BlankLayout",
    name: "سازمان - ثبت نام",
  },
  {
    path: "/organization/manager/profile",
    exact: true,
    component: lazy(() => import("../pages/organization/manager/profile")),
    layout: "PanelLayout",
    name: "سازمان - پروفایل",
    navBoxItems: OrganizationManagerNavBoxItems,
  },
  {
    path: "/organization/manager/staff",
    exact: true,
    component: lazy(() => import("../pages/organization/manager/staff")),
    layout: "PanelLayout",
    name: "سازمان - کارمندان",
    navBoxItems: OrganizationManagerNavBoxItems,
  },
  {
    path: "/organization/manager/staff/add",
    exact: true,
    component: lazy(() => import("../pages/organization/manager/staff/add")),
    layout: "PanelLayout",
    name: "سازمان - افزودن کارمند",
    navBoxItems: OrganizationManagerNavBoxItems,
  },
  {
    path: "/organization/manager/services",
    exact: true,
    component: lazy(() =>
      import("../pages/organization/manager/services/index")
    ),
    layout: "PanelLayout",
    name: "سازمان - سرویس ها",
    navBoxItems: OrganizationManagerNavBoxItems,
  },
  {
    path: "/organization/manager/operator",
    exact: true,
    component: lazy(() =>
      import("../pages/organization/manager/operator/index")
    ),
    layout: "PanelLayout",
    name: "سازمان - اپراتور ها",
    navBoxItems: OrganizationManagerNavBoxItems,
  },
  {
    path: "/organization/manager/service/:code?",
    exact: true,
    component: lazy(() => import("../pages/organization/manager/service")),
    layout: "PanelLayout",
    name: "سازمان - ثبت سرویس",
    navBoxItems: OrganizationManagerNavBoxItems,
  },
  {
    path: "/organization/manager/inventories/:code",
    exact: true,
    component: lazy(() => import("../pages/common/inventories")),
    layout: "PanelLayout",
    name: "مدرسه - برنامه حرکت",
    navBoxItems: OrganizationManagerNavBoxItems,
  },
  {
    path: "/fruit",
    exact: true,
    component: lazy(() => import("../pages/fruit")),
    layout: "BlankLayout",
    name: "بهمراه میوه",
  },
];

export default Routes;
